import { defineStore } from 'pinia'
import { ref, reactive, watch } from 'vue'
import { router } from '@/router'

interface optionItem {
  contractId: string // 合同id
  type?: 'sign' | 'remove' // 签署协议  接触协议
}

export const useGlobalContract = defineStore('useGlobalContract', () => {
  const contractVisible = ref(false)

  const contractOption = reactive<optionItem>({
    contractId: '',
    type: 'sign'
  })

  const updateTime = ref(0)

  function init(option: optionItem) {
    contractVisible.value = false
    contractOption.contractId = option.contractId
    contractOption.type = option.type
    setTimeout(() => {
      setVisible(true)
    }, 100)
  }

  function setVisible(bool: boolean) {
    contractVisible.value = bool
  }

  function setUpdateTime(time: number | undefined = undefined) {
    updateTime.value = time || new Date().getTime()
  }

  watch(
    () => router.currentRoute,
    val => {
      // 401的时候 关闭
      if (unref(val)?.path === '/login') {
        setVisible(false)
      }
    },
    { deep: true }
  )

  return {
    contractVisible,
    contractOption,
    updateTime,
    init,
    setVisible,
    setUpdateTime
  }
})
